import { lazy } from "react";
import { Send } from "lucide-react";
import type { AdminModule } from "../types";

const Summary = lazy(() => import("./pages/Summary").then((m) => ({ default: m.Summary })));
const Entries = lazy(() => import("./pages/Entries").then((m) => ({ default: m.Entries })));

/**
 * RFC-330 — Outbox admin module. Surfaces the two consumers (analytics +
 * search) and lets ops pause / replay / purge / flush-now without ssh.
 *
 * Nav label says "Event outbox": "Outbox" on its own reads as mail to anyone
 * who has not worked on the pipeline.
 */
export const outboxModule: AdminModule = {
  key: "outbox",
  label: "Event outbox",
  description: "Analytics and search consumers: lag, failures, replay and purge.",
  group: "operations",
  icon: Send,
  requiredPermission: "admin.outbox.read",
  routes: [
    { path: "summary", label: "Summary", element: <Summary /> },
    { path: "entries", label: "Entries", element: <Entries /> },
  ],
};
